/**
 * Lê o header `Retry-After` (segundos ou data HTTP) e devolve os segundos de espera.
 * `null` quando ausente, inválido ou já no passado.
 */
export function parseRetryAfterSeconds(value: unknown, now: number = Date.now()): number | null {
    if (typeof value !== "string" && typeof value !== "number") return null;
    const raw = String(value).trim();
    if (!raw) return null;

    if (/^\d+$/.test(raw)) {
        const seconds = Number(raw);
        return seconds > 0 ? seconds : null;
    }

    const at = Date.parse(raw);
    if (Number.isNaN(at)) return null;
    const seconds = Math.ceil((at - now) / 1000);
    return seconds > 0 ? seconds : null;
}
